export enum GameStatus {
	Playing = 'playing',
	Won = 'won',
	Completed = 'completed',
	GameOver = 'gameOver',
}

export interface Position {
	x: number;
	y: number;
}

export interface LetterQ {
	position: Position;
	letter: string;
	collected: boolean;
	colorSeed: number;
}

export interface HatCollectible {
	position: Position;
	collected: boolean;
	id: number;
}

export type Direction = 'UP' | 'DOWN' | 'LEFT' | 'RIGHT';
